<template>
  <div>
    <v-text-field
      outlined
      dense
      label="Period"
      hide-details="auto"
      type="number"
      :value="selectedNode.settings.period"
      @input="(val) => onUpdate(val, 'settings.period')"
    ></v-text-field>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters: workflowDetailsGetters } =
  createNamespacedHelpers("workflows/details");

export default {
  name: "recent-ribbons-settings",
  computed: {
    ...workflowDetailsGetters({
      selectedNode: "SELECTED_NODE",
    }),
  },
  methods: {
    onUpdate(value, path) {
      this.$emit("update", value, path);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
